export default function HeaderTable({columns, selectable = false, allSelected = false, onToggleSelectAll = () => {}, hasRows = false}) {
    return (
        <>
        <thead className="bg-gray-100 sticky top-0 z-4">
        <tr>
          {selectable && (
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <input
                type="checkbox"
                checked={allSelected}
                onChange={onToggleSelectAll}
                disabled={!hasRows}
                className="h-4 w-4"
              />
            </th>
          )}
          {
            columns.map((element, index) => (
            <th key={index} className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{ element.display }</th>)
          )}
        </tr>
      </thead>
        </>
    )
}